export class AppOauth2RevokeTokenRequest
{
    constructor(
            public readonly token:string, 
            public readonly isRefreshToken:boolean
        )
    {}
}
